import axios from "axios"

export interface ReportIssueProps {
    url: string
    description: string
    userAgent: string
    assignmentId?: string
}

export async function reportIssue({ url, description, userAgent, assignmentId } : ReportIssueProps) {
    const res = await axios.post("/api/report-issue", { url, description, userAgent, assignmentId })
    return res
}
